import { IAbortController, PlAbortController } from './AbortController';

export interface IAbortControllerFactory {
    createAbortController(): IAbortController;
}

export class AbortControllerFactory implements IAbortControllerFactory {
    createAbortController(): IAbortController {
        return new PlAbortController();
    }
}
